import styled from 'styled-components';
import { THEME } from '@/common/styles/theme';

export const Overlay = styled.div`
	position: fixed;
	inset: 0;
	z-index: 8000;
	display: flex;
	align-items: center;
	justify-content: center;
	padding: 16px;
	background: rgba(2, 1, 6, 0.82);
	backdrop-filter: blur(8px);
`;

export const Dialog = styled.div`
	width: 100%;
	max-width: 420px;
	display: grid;
	gap: 16px;
	padding: 28px 22px;
	border-radius: 20px;
	border: 1px solid ${THEME.line};
	background: ${THEME.panel};
	box-shadow: ${THEME.shadow};
	text-align: center;
`;

export const Title = styled.h2`
	margin: 0;
	color: ${THEME.text};
	font-size: 1.15rem;
	font-weight: 800;
	line-height: 1.35;
`;

export const Description = styled.p`
	margin: 0;
	color: ${THEME.muted};
	font-size: 0.88rem;
	line-height: 1.45;
`;

export const AcceptButton = styled.button`
	padding: 16px 18px;
	border: none;
	border-radius: 14px;
	background: ${THEME.gradientPrimary};
	color: #fff;
	font-family: ${THEME.fontApp};
	font-size: 1rem;
	font-weight: 800;
	cursor: pointer;
	box-shadow: ${THEME.glow};
`;

export const DeclineButton = styled.button`
	border: none;
	background: transparent;
	color: ${THEME.soft};
	font-size: 0.8rem;
	text-decoration: underline;
	cursor: pointer;
`;
